
import React, { ReactNode, useState } from 'react';
import axios from 'axios';
// import '../Pincodefinder/Style.css';
// import '../Steelcity/css/style.css';
// import '../Steelcity/css/bootstrap.min.css';
// import '../Steelcity/css/responsive.css';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Row, Col, Card } from 'react-bootstrap';
import Swal from 'sweetalert2';
import personPhoto from "../Logo/personPhoto.png";
import jdcargo from "../Logo/jdcargologo.png";
// import Aslogistics from "../Logo/Aslogisticslogo.png";
import bsworldwide from "../Logo/Bsworlwidelogo.png";
import FastLog from "../Logo/fastmovlogo.png";
import as from "../Logo/Aslogisticslogofuture.png";
import serviceIcon from "../Logo/service247.png";
import asbaner from "../Logo/asbanner.jpg";



interface TempodEntry {
    DocketNo: string;
    DelvDt: string;
    DelvTime: string;
    Destination_Name: string;
    Remark?: string | null;   // ✅ FIX
    Status: string;
}


interface TrackingRecord {
    podHistory: TempodEntry[];
    StatusEntry: TempodEntry[];
    DocketNo: string;
    InvoiceNo: string;
    ExptDateDelivery: string;
    VendorAwbNo: string;
    bookdate: string;
    ConsigneeName: string;
    Status: string;
    Qty: string;
    Destination_Name: string;
    Origin_Name: string;
    Consignee_Mob: string;
    Mode: string;
    EWaybill: string,
    recvName: string;
    statusDt: string;
    DelvTime: string;
    remark: ReactNode;
    tempodData: TempodEntry[];
    ImageLink: string;
}

const FastMovTracking: React.FC = () => {
    const [searchValue, setSearchValue] = useState('');
    const [trackingData, setTrackingData] = useState<TrackingRecord[]>([]);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState('');
    const [currentStep, setCurrentStep] = useState(1);
    const [menuOpen, setMenuOpen] = useState(false);



    const statusToStep: { [key: string]: number } = {
        'Shipment Arrived': 1,
        'Shipment Booked': 1,
        'Shipment ': 1,

        'In Transit': 2,

        'Out for Delivery': 3,
        'Delivered': 3,
        'Shipment Delivered': 3,
    };



    const handleButtonClick = () => setShowImage(!showImage);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = e.target.value.slice(0, 200);
        setSearchValue(inputValue);
        setError('');
        setTrackingData([]);
    };




    // const fetchData = async () => {
    //     try {
    //         setError(""); // clear previous error

    //         if (searchValue.trim() === "") {
    //             setError("Please enter one or more tracking numbers separated by commas.");
    //             alert("Please enter one or more tracking numbers separated by commas.");
    //             return;
    //         }

    //         const searchInputs = searchValue
    //             .split(",")
    //             .map((item) => item.trim())
    //             .filter(Boolean);

    //         if (searchInputs.length === 0) {
    //             setError("Please enter valid tracking numbers or reference numbers.");
    //             alert("Please enter valid tracking numbers or reference numbers.");
    //             return;
    //         }

    //         // const res = await axios.get(
    //         //     "https://jaimarutilogistics.com/ShipwayApi/Master/WebsiteTrackingdata",
    //         //     {
    //         //         params: {
    //         //             CNoteNo: searchInputs.join(","),
    //         //             refNo: searchInputs.join(","),
    //         //         },
    //         //     }
    //         // );

    //         const docket = searchValue.trim();
    //         const res = await axios.get(
    //             // 'https://a2zlogisticsolutions.in/A2ZLogisticsApi/TrackingData',
    //             // 'https://trackerex.com/TrackingControlerNodeJsApi/TrackingData',
    //             'http://localhost:27006/TrackingControlerNodeJsApi/TrackingData',
    //             {
    //                 params: {
    //                     VendorName: 'AGL', // 👈 ADD THIS
    //                     awbNo: docket,
    //                     refNo: docket
    //                 }
    //             }
    //         );

    //         const data = res.data;

    //         if (data.status === 1 && data.Data) {
    //             const updatedData = data.Data.map((item: TrackingRecord) => ({
    //                 ...item,
    //                 ImageLink: `https://jaimarutilogistics.com/ShipwayApi/POD_Image/${item.DocketNo}.jpg`,
    //             }));

    //             setTrackingData(updatedData);
    //             setSearchValue("");

    //             if (updatedData.length > 0) {
    //                 setCurrentStep(statusToStep[updatedData[0].Status] || 1);
    //             }
    //         } else {
    //             setTrackingData([]);
    //             setError("Docket Not Found");
    //             alert("Docket Not Found");
    //             setSearchValue("");
    //         }
    //     } catch (err: any) {
    //         console.error(err);

    //         const message =
    //             err.response?.data?.message ||
    //             "Failed to fetch data. Please check your internet connection or try again later.";

    //         setError(message);
    //         alert(message);
    //         setSearchValue("");
    //     }
    // };

    const fetchData = async () => {
        try {
            if (!searchValue.trim()) {
                setError('Please enter a tracking number.');
                return;
            }

            const docket = searchValue.trim();

            const res = await axios.get(
                'https://arhatglobal.com/PodImgGet/tracking',
                {
                    params: {
                        VendorName: 'BSW',
                        awbNo: docket,
                        refNo: docket
                    }
                }
            );

            const data = res.data;
            console.log(data, 'API response ====================');

            // ✅ FIX: correct key (data.data not data.Data)
            if (data?.status === 1 && Array.isArray(data.data)) {

                const checkImageExists = (url: string): Promise<boolean> => {
                    return new Promise((resolve) => {
                        const img = new Image();
                        img.src = url;
                        img.onload = () => resolve(true);
                        img.onerror = () => resolve(false);
                    });
                };

                const tryImageExtensions = async (awbNo: string): Promise<string | null> => {
                    if (!awbNo) return null;   // 🔥 important

                    const extensions = ['jpg', 'jpeg', 'png'];

                    for (const ext of extensions) {
                        const url = `https://arhatglobal.com/Podimages/${awbNo}.${ext}`;
                        const exists = await checkImageExists(url);
                        if (exists) return url;
                    }
                    return null;
                };

                const updatedData = await Promise.all(
                    data.data.map(async (item: any) => {
                        const imageUrl = await tryImageExtensions(item.awbNo);

                        return {
                            ...item,
                            ImageLink: imageUrl,

                            // ✅ FIX: handle all possible API keys
                            podHistory: Array.isArray(item.podHistory) ? item.podHistory : Array.isArray(item.tempodData) ? item.tempodData : Array.isArray(item.StatusEntry) ? item.StatusEntry : []
                        };
                    })
                );
                setTrackingData(updatedData);
                setError('');
                setSearchValue('');

                if (updatedData.length > 0) {
                    const status = updatedData[0].Status;
                    setCurrentStep(getStepFromStatus(status));
                }

            } else {
                setTrackingData([]);

                Swal.fire({
                    icon: 'warning',
                    title: 'Docket Not Found',
                    text: 'The entered docket number was not found.',
                });
            }

        } catch (error: any) {
            console.error('Error:', error);

            setTrackingData([]);
            setError(
                error.response?.data?.message ||
                'Failed to fetch data. Please check your internet connection.'
            );
        }
    };


    const getStepFromStatus = (status: string) => {
        const s = status?.toLowerCase().trim();

        if (s.includes('deliver')) return 3; // 🔥 सबसे safe
        if (s.includes('out for delivery')) return 3;
        if (s.includes('transit')) return 2;

        return 1;
    };

    return (
        <>

            {/* ================= DESKTOP NAVBAR ================= */}
            <header className="navbar-desktop">
                <div className="navbar-left">
                    <img
                        src={FastLog}
                        alt="Bs Worldwide"
                        className="navbar-logo2"
                        style={{ height: "80px", width: "auto" }}
                    />
                </div>

                <nav className="navbar-center">
                    <a href="https://bsworldwide.net/Home/Index">Home</a>
                    <a href="https://bsworldwide.net/Home/About_us">About Us</a>
                    <a href="https://bsworldwide.net/Home/Service">Services</a>
                    <a href="#">Tracking</a>
                    <a href="https://bsworldwide.net/Home/Contact_us">Contact Us</a>
                    <a href="https://bsworldwide.net/Home/Contact_us">Login</a>
                </nav>

                <div className="track-wrapper">
                    <input
                        type="text"
                        className="track-input-new"
                        placeholder="Enter AWB Number"
                        value={searchValue}
                        onChange={handleInputChange}
                    />
                    <button onClick={fetchData} className="track-btn-new">
                        Track Shipment
                    </button>
                </div>
            </header>

            {/* ================= MOBILE / TABLET NAVBAR ================= */}
            <header className="navbar-mobile">
                <div className="mobile-header">
                    <button
                        className="menu-toggle"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        ☰
                    </button>

                    <img src={bsworldwide} alt="As Logistics" className="mobile-logo" />
                </div>

                {menuOpen && (
                    <div className="mobile-menu">
                        <li><a href="https://bsworldwide.net/Home/Index">Home</a></li>
                        <li><a href="https://bsworldwide.net/Home/About_us">About Us</a></li>
                        <li><a href="https://bsworldwide.net/Home/Service">Our Services</a></li>
                        <a href="#">Tracking</a>
                        <li><a href="https://bsworldwide.net/Home/Contact_us">Contact Us</a></li>
                        <li><a href="https://bsworldwide.net/User/User_login">Login</a></li>

                        <div className="mobile-track">
                            <input
                                type="text"
                                className="track-input-new"
                                placeholder="Enter AWB Number"
                                value={searchValue}
                                onChange={handleInputChange}
                            />
                            <button onClick={fetchData} className="track-btn-new">
                                Track Shipment
                            </button>
                        </div>
                    </div>
                )}
            </header>





            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-10 col-sm-12">
                        <h5 className="BLuedarttracking1 text-center"><b>Fastmove Cargo </b></h5>

                        {trackingData.length > 0 ? (
                            trackingData.map((record, index) => (
                                <div key={index} className="p-4 mb-4">
                                    <div className="table-responsive-custom">
                                        <table className="custom-table">
                                            <thead>
                                                <tr>
                                                    <th>Waybill No</th>
                                                    <th>Invoice No</th>
                                                    <th>Expected Date of Delivery</th>
                                                    <th>Status</th>
                                                    <th>Date of Delivery</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{record.DocketNo}</td>
                                                    <td>{record.InvoiceNo}</td>
                                                    <td>{record.ExptDateDelivery}</td>
                                                    <td>{record.Status}</td>
                                                    <td>{record.statusDt}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            ))
                        ) : (
                            <div className="text-center">No tracking data available.</div>
                        )}

                        {/* Progress Steps */}
                        <div className="steps-wrapper">
                            <div className="steps-container">

                                {[1, 2, 3].map((number) => (
                                    <div key={number} className="step">

                                        <div className={`step-circle2 ${number <= currentStep ? 'active' : ''}`}>
                                            {number}
                                        </div>

                                        <div className="step-label">
                                            {number === 1
                                                ? 'Shipped'
                                                : number === 2
                                                    ? 'In Transit'
                                                    : 'Delivered'}
                                        </div>

                                    </div>
                                ))}

                                <div className="progress-line">
                                    <div
                                        className="progress-fill"
                                        style={{ width: `${((currentStep - 1) / 2) * 100}%` }}
                                    ></div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>


            {/* Tabs Section */}
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10 col-md-10 col-sm-12">
                        <Tabs defaultActiveKey="details" id="uncontrolled-tab-example" className="custom-tabs">
                            {/* Shipment Details Tab */}
                            <Tab eventKey="details" title="Shipment Details">
                                {trackingData.length > 0 ? (
                                    trackingData.map((record, index) => (

                                        <div key={index} className="mb-4">
                                            <div className="shipment-table-container">
                                                <table className="blue-table">
                                                    <thead className='blue-table'>
                                                        <tr>
                                                            <th className="blue-header">Shipment Details</th>
                                                            <th className="blue-header">Details</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr><td>Waybill No</td><td>{record.DocketNo}</td></tr>
                                                        <tr><td>Forwarding No</td><td>{record.VendorAwbNo || '-'}</td></tr>
                                                        <tr><td>Pickup Date</td><td>{record.bookdate}</td></tr>
                                                        <tr><td>From</td><td>{record.Origin_Name}</td></tr>
                                                        <tr><td>To</td><td>{record.Destination_Name}</td></tr>
                                                        <tr><td>Qty</td><td>{record.Qty}</td></tr>
                                                        <tr><td>Status</td><td>{record.Status}</td></tr>
                                                        <tr><td>Date of Delivery</td><td>{record.statusDt || '-'}</td></tr>
                                                        <tr><td>Time of Delivery</td><td>{record.DelvTime || '-'}</td></tr>
                                                        <tr><td>Receiver Name</td><td>{record.recvName || '-'}</td></tr>
                                                    </tbody>
                                                </table>
                                            </div>




                                            {/* Show/Hide POD Button */}
                                            <button className="pod-btn-blue mt-3" onClick={handleButtonClick}>
                                                {showImage ? "Hide Image" : "Show POD Image"}
                                            </button>

                                            {/* POD Image */}
                                            {showImage && record.ImageLink && (
                                                <div className="image-container mt-3 text-center">
                                                    <img
                                                        src={record.ImageLink}
                                                        alt="POD"
                                                        className=""
                                                        style={{ maxWidth: "600px", borderRadius: "6px" }}
                                                    />
                                                </div>
                                            )}
                                        </div>


                                    ))
                                ) : (
                                    <div className="text-center">No shipment details available.</div>
                                )}
                            </Tab>

                            {/* Status and Scans Tab */}
                            <Tab eventKey="status" title="Status and Scans">
                                {trackingData.length > 0 ? (
                                    trackingData.map((record, index) => (
                                        <div key={index} className="mb-3">
                                            <div className="scrollable-table">
                                                <table className="blue-table">
                                                    <thead>
                                                        <tr>
                                                            <th>DocketNo</th>
                                                            <th>Location</th>
                                                            <th>Status</th>
                                                            <th>Status Date</th>
                                                            <th>Time</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {record.podHistory && record.podHistory.length > 0 ? (
                                                            record.podHistory.map((entry: TempodEntry, idx: number) => (
                                                                <tr key={idx}>
                                                                    <td>{entry.DocketNo}</td>
                                                                    <td>{entry.Destination_Name}</td>
                                                                    <td>{entry.Status}</td>
                                                                    <td>{entry.DelvDt}</td>
                                                                    <td>{entry.DelvTime}</td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan={5}>No scans available.</td>
                                                            </tr>
                                                        )}

                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center">No status and scans available.</div>
                                )}
                            </Tab>



                        </Tabs>
                    </div>
                </div>
            </div>


            {/* News Section */}
            <div className="container mt-4">
                <div className="marquee-container">
                    <div className="marquee-content">
                        {/* <Row className="flex-nowrap">
              {news.map((item, idx) => (
                <Col key={idx} className="marquee-col" style={{ position: "relative" }}>
                  <Card
                    className="shadow-sm border-0 h-100 position-relative"
                    style={{
                      borderRadius: "15px",
                      padding: "20px",
                      textAlign: "left",
                      overflow: "hidden",
                    }}
                  >
                    <span className="new-badge">NEW</span>
                    <Card.Body>
                      <Card.Title style={{ fontWeight: "700", fontSize: "1.2rem", color: "#222" }}>
                        {item.date}
                      </Card.Title>
                      <Card.Text>
                        <a href={item.link} style={{ color: "#007bff", textDecoration: "none", fontWeight: "500" }}>
                          {item.title}
                        </a>
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row> */}
                    </div>
                </div>
            </div>



            {/* Footer */}

            <footer className="jd-footer">
                <div className="container">
                    <div className="row">

                        {/* Column 1 */}
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                            <img src={FastLog} alt="Logo" className="as" />

                            <p>
                                We are committed and dedicated in fulfilling our obligation to our valued customer by offering quality services that meets all the demands and day to day requirements of our clients, which makes us a reputed courier and cargo company in India... Read More
                            </p>

                            <div className="jd-social">
                                <a href="#"><i className="fab fa-instagram"></i></a>
                                <a href="#"><i className="fab fa-facebook"></i></a>
                            </div>
                        </div>

                        {/* Column 2 */}
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                            <h4>Quick Links</h4>
                            <ul>
                                <li><a href="https://bsworldwide.net/Home/Index">Home</a></li>
                                <li><a href="https://bsworldwide.net/Home/About_us">About Us</a></li>
                                <li><a href="https://bsworldwide.net/Home/Service">Our Services</a></li>
                                <li><a href="#">Premium Air</a></li>
                                <li><a href="#">Terms Of Service</a></li>
                                <li><a href="https://bsworldwide.net/Home/Contact_us">Contact Us</a></li>
                                <li><a href="https://bsworldwide.net/User/User_login">Login</a></li>
                            </ul>
                        </div>

                        {/* Column 3 */}
                        <div className="col-lg-3 col-md-6 col-sm-12 mb-4">
                            <h4>Our Services</h4>
                            <ul>
                                <li><a href="#">Air Freight</a></li>
                                <li><a href="#">Train Freight</a></li>
                                <li><a href="#">Road Freight</a></li>
                                <li><a href="#">Warehousing</a></li>
                                <li><a href="#">Supply Chain</a></li>
                                <li><a href="#">Packaging</a></li>
                            </ul>
                        </div>

                        {/* Column 4 */}
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <h4>Get in Touch</h4>
                            <p>
                                A-13 , GALI NO -1 , KAUSHIK ENCLAVE NEAR BURARI HOSPITAL ,Burari  <br />
                                Delhi-110084
                            </p>
                            <p>
                                <strong>Email:</strong>info@fastmovecargo.com<br />
                                Contact: +91 9625894856 - 7011356101 9811613652  <br />
                                <a href="mailto:info@bsworldwide.net">info@fastmovecargo.com</a>
                            </p>
                        </div>

                    </div>
                </div>



                <div className="jd-footer-bottom">
                    © {new Date().getFullYear()} Fastmove Cargo . All rights reserved.
                </div>

            </footer>

        </>
    );
};

export default FastMovTracking;
